export default {
    setToken(token) {
        localStorage.setItem("token", JSON.stringify({
            token: token,
            time: new Date().getTime()
        }))
    },

    getToken() {
        let token = localStorage.getItem("token");
        if (token) {
            return JSON.parse(token).token;
        } else {
            return null;
        }
    },

    clearToken() {
        localStorage.removeItem('token');
    },

    isRefresh() {
        let token = localStorage.getItem("token");
        if (token) {
            return new Date().getTime() - JSON.parse(token).time > 12 * 60 * 60 * 1000;
        } else {
            return true;
        }
    }
}
